export default function LoadingSpinner({ message = "Loading...", fullscreen = true }) {
  return (
    <div className={`flex flex-col justify-center items-center ${fullscreen ? "min-h-screen" : "py-8"}`}>
      {/* Bauhaus-inspired ring spinner (CSS only) */}
      <span
        className="relative inline-block w-12 h-12 mb-4"
        role="status"
        aria-live="polite"
        aria-label={message}
      >
        <span className="absolute inset-0 rounded-full border-[3px] border-gray-300/70" />
        <span className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-blue-600 animate-spin" />
      </span>
      <p className="text-gray-600">{message}</p>
    </div>
  );
}
